module.exports = __webpack_public_path__ + "static/link-image-1e8028eda26d466ca69e7b05fafc8b7f.png";